import { render, staticRenderFns } from "./Date.vue?vue&type=template&id=08ad2a7c"
import script from "./Date.vue?vue&type=script&lang=js"
export * from "./Date.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports